import React, { useState, useEffect } from "react";
import Head from "next/head";
import Link from "next/link";
import Image from "next/legacy/image";
import styles from "../styles/pages/Contactus.module.scss";
import {
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaYoutube,
} from "react-icons/fa";
import Topbanner from '../components/Topbanner/Topbanner';
import useContactForm from "../hooks/useContactForm"
import sendEmail from "../lib/sendEmail";
import Contactusform from "../components/Contactusform/Contactusform";
import BreadCrumbSchema from "../components/Schema/HotelSchema/breadcrumb";

const Contactus = () => {
    const { values, handleChange } = useContactForm();
    const [responseMessage, setResponseMessage] = useState(
        { isSuccessful: false, message: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setTimeout(() => {
            setResponseMessage({ isSuccessful: true })
        }, 3000)
        try {
            const req = await sendEmail(values.fullname, values.email, values.phoneno, values.subject, values.message);
            if (req.status === 250) {
                setResponseMessage({ isSuccessful: true, message: 'Thank you for your message.' });
                alert("Thank you for your message.")
            }

        } catch (e) {
            setResponseMessage({
                isSuccessful: false,
                message: 'Oops something went wrong. Please try again.',
            });
        }
    };

    return (
        <>
            <Head>
                <title>Book Hotel in Kufri | The Twin Towers Hotel in Shimla</title>
                <meta name="description" content="The Twin Towers Hotel in Shimla-Get In Touch with The Twin Towers Hotel and Book hotel rooms in Kufri | The Twin Towers Hotel" />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.hoteltwintowers.com/contact-us" />
            </Head>
            <Topbanner bgImage={"/images/contact-banner.png"} title={"Contact Us"} />
            <section className={`${styles.contactus} common_padding pb-0`}>
                <div className='container'>
                    <div className='row'>
                        <div className={`${styles.contact_left} col-md-4 common_title`}>
                            <h2> Get In Touch</h2>
                            <p>If you want to learn more about our services, contact us through this form or call us at</p>
                            <div className={styles.contect_info}>
                                <Image src="/icons/call-black.svg" width={36} height={36} className={styles.footer_icon} alt="Reservation icon" />
                                <div>
                                    <h4>Reservation</h4>
                                    <Link href="tel:9318192605">+91 93181-92605</Link><br />
                                    <Link href="tel:9317192601">+91 93171-92601</Link><br />
                                    {/* <Link href="tel:9317192605">+91 93171-92605</Link><br /> */}
                                    <Link href="tel:9318192601">+91 93181-92601</Link>
                                </div>
                            </div>
                            <div className={styles.contect_info}>
                                <Image src="/icons/mail-black.svg" width={36} height={36} className={styles.footer_icon} alt="Email Icon" />
                                <div>
                                    <h4>email</h4>
                                    <Link href="mailto:info@hoteltwintowers.com">info@hoteltwintowers.com</Link><br />
                                </div>
                            </div>
                            <div className={styles.contect_info}>
                                <Image src="/icons/map-black.svg" width={40} height={36} className={styles.footer_icon} alt="Map icon" />
                                <div>
                                    <h4>Address</h4>
                                    <Link href="https://g.page/hotel-the-twin-towers-new-kufri">NH 05, New kufri, Galu, Hills, Shimla, Himachal Pradesh, India 171209</Link><br />
                                </div>
                            </div>
                            <div className={styles.contact_social_links}>
                                <div className={styles.icon}>
                                    <Link className={styles.fb} href="https://www.facebook.com/twintower.hotel" target="_blank">
                                        <FaFacebookF />
                                    </Link>
                                </div>
                                <div className={styles.icon}>
                                    <Link href="https://www.instagram.com/hotel_twintowers" className={styles.insta} target="_blank">
                                        <FaInstagram />

                                    </Link>
                                </div>
                                <div className={styles.icon}>
                                    <Link className={styles.linkedin} href="https://www.linkedin.com/in/the-twin-towers-hotel" target="_blank">
                                        <FaLinkedinIn />
                                    </Link>
                                </div>
                                <div className={styles.icon}>
                                    <Link className={styles.linkedin} href="https://www.youtube.com/@thetwintowershotel" target="_blank">
                                        <FaYoutube />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.contact_right} col-md-8 common_title`}>
                            <h2> Send A Message </h2>
                            {/* <Contactusform /> */}
                            <form className='row' onSubmit={handleSubmit}>
                                <div className='col-md-6'>
                                    <input id="fullname"
                                        type="text"
                                        name="fullname"
                                        onChange={handleChange}
                                        value={values.fullname}
                                        required
                                        className={styles.form_control}
                                        placeholder="Full Name" />
                                </div>
                                <div className='col-md-6'>
                                    <input id="email"
                                        type="email"
                                        name="email"
                                        value={values.email}
                                        onChange={handleChange}
                                        required
                                        className={styles.form_control} placeholder="Email" />
                                </div>
                                <div className='col-md-6'>
                                    <input
                                        type="number"
                                        name="phoneno"
                                        value={values.phoneno}
                                        onChange={handleChange}
                                        required
                                        className={styles.form_control}
                                        id="phoneno" placeholder="Phone" />
                                </div>
                                <div className='col-md-6'>
                                    <input id="subject"
                                        type="text"
                                        name="subject"
                                        value={values.subject}
                                        onChange={handleChange}
                                        required
                                        className={styles.form_control} placeholder="Subject" />
                                </div>
                                <div className='pb-2'>
                                    <textarea id="message"
                                        name="message"
                                        value={values.message}
                                        onChange={handleChange}
                                        required
                                        className={styles.from_textarea} rows="4"
                                        placeholder="Message"
                                    ></textarea>
                                </div>
                                <div className={`${styles.submit_btn} col-md-6 col-sm-12`}>
                                    <button type="submit" className='common_btn'> Submit</button>
                                </div>
                                {responseMessage.isSuccessful === true ? (
                                    <p className=" success">We appreciate you contacting us. One of our customer happiness members will be getting back to you shortly.</p>
                                ) : ('')}
                            </form>
                        </div>

                    </div>
                </div>
                <div className='pt-5'>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13666.806624298124!2d77.2852872!3d31.0902248!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390583ff77109ab1%3A0xb1b39c68310de225!2sThe%20Twin%20Towers%20Hotel%20New%20Kufri!5e0!3m2!1sen!2sin!4v1668662868345!5m2!1sen!2sin"
                        width="100%" height="450" allowFullScreen="" loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </section>
            <BreadCrumbSchema />
        </>
    );
}
export default Contactus;
